import CharlesButton from "components/base/Button";
import { Input, Text } from "components/base/Form";
import { useState } from "react";
import { v4 } from "uuid";

const ContainerForm = ({ parentId, onCreate }) => {
  const [name, setName] = useState("Outer Carton");
  const [size, setSize] = useState("L: 40cm W: 30cm H: 20cm");
  const [qty, setQty] = useState(20);
  const [remark, setRemark] = useState("");
  const [images, setImages] = useState([]);

  return (
    <div>
      <div className="-mx-2 whitespace-nowrap">
        <table>
          <tbody>
            <tr>
              <td>
                <label htmlFor="">Name: </label>
              </td>
              <td className="w-full">
                <Input value={name} onChange={(e) => setName(e.target.value)} />
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="">Size: </label>
              </td>
              <td>
                <Input value={size} onChange={(e) => setSize(e.target.value)} />
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="">Qty: </label>
              </td>
              <td>
                <Input
                  type="number"
                  value={qty}
                  onChange={(e) => setQty(Number(e.target.value))}
                />
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="">Remark: </label>
              </td>
              <td>
                <Text
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <hr />

      <div>
        <CharlesButton
          primary
          onClick={() =>
            onCreate({
              id: v4(),
              name,
              size,
              qty,
              parentId,
            })
          }
        >
          Create Container
        </CharlesButton>
      </div>
    </div>
  );
};

export default ContainerForm;
